import HeroChapter from "@/components/home/HeroChapter";
import RestorationStory from "@/components/story/RestorationStory";
import IntroChapter from "@/components/home/IntroChapter";
import ApartChapter from "@/components/home/ApartChapter";
import MinutesChapter from "@/components/home/MinutesChapter";
import ServicesChapter from "@/components/home/ServicesChapter";
import ProcessChapter from "@/components/home/ProcessChapter";
import AudiencesChapter from "@/components/home/AudiencesChapter";
import AreasChapter from "@/components/home/AreasChapter";
import FinalCtaChapter from "@/components/home/FinalCtaChapter";

// Cinematic, full-viewport chapters. Copy for each chapter lives in its component.
export default function Home() {
  return (
    <div data-testid="page-home" className="bg-[hsl(var(--gaza-teal-deep))]">
      <HeroChapter />
      <RestorationStory />
      <IntroChapter />
      <ApartChapter />
      <MinutesChapter />
      <ServicesChapter />
      <ProcessChapter />
      <AudiencesChapter />
      <AreasChapter />
      <FinalCtaChapter />
    </div>
  );
}
